<template>
  <div id="generalreport">
    <!-- {{PlugJson}} -->
  </div>
</template>

<script>
export default {
  name: "generalreport"
};
</script>

<style scoped>
</style>